import React from 'react'
import { ButtonDesigns, ButtonTypes } from 'src/components/Button/Button'
import PhysicalCardsTable from 'src/components/DataGrid/tables/PhysicalCardsTable/PhysicalCardsTable'
import LayoutShell from 'src/components/LayoutShell/LayoutShell'
import { SubnavDesign } from 'src/components/Subnav/Subnav'
import Trns from 'src/localization/Trns'
import { UserFeature } from 'src/models/user.models'
import { registerAccountUrl } from 'src/navigation/urls'
import { useQueryUserFeatures } from 'src/queries/auth.queries'

const CardsPhysicalCards = (): React.ReactElement => {
  const { REGISTER_ACCOUNT: canRegisterAccount } =
    useQueryUserFeatures([UserFeature.REGISTER_ACCOUNT]).data || {}

  return (
    <LayoutShell
      subnavDesign={SubnavDesign.Floating}
      subnavOptions={[]}
      content={<PhysicalCardsTable />}
      title={<Trns source={'Physical Cards'} />}
      buttons={
        canRegisterAccount
          ? [
              {
                design: ButtonDesigns.designCta,
                type: ButtonTypes.button,
                text: <Trns source={'Enroll Card'} />,
                linkProps: {
                  to: registerAccountUrl(),
                  ariaLabel: 'Enroll Card',
                  testId: 'enroll-card-btn',
                },
              },
            ]
          : []
      }
    />
  )
}

export default CardsPhysicalCards
